module.exports = __webpack_public_path__ + "img/bluetagcross.cbb6de40.svg";